!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, a = {}, n = t.parcelRequire5f74;
  null == n && ((n = function(t) {
    if (t in e) return e[t].exports;
    if (t in a) {
      var n = a[t];
      delete a[t];
      var r = {
        id: t,
        exports: {}
      };
      return e[t] = r, n.call(r.exports, r, r.exports), r.exports;
    }
    var o = new Error("Cannot find module '" + t + "'");
    throw o.code = "MODULE_NOT_FOUND", o;
  }).register = function(t, e) {
    a[t] = e;
  }, t.parcelRequire5f74 = n), (0, n.register)("gjV2B", function(t, e) {
    var a, n, r, o;
    a = t.exports, n = "debounce", r = function() {
      return i;
    }, Object.defineProperty(a, n, {
      get: r,
      set: o,
      enumerable: !0,
      configurable: !0
    });
    const i = (t, e) => {
      let a;
      const n = (...n) => {
        clearTimeout(a), a = setTimeout(() => {
          clearTimeout(a), t(...n);
        }, e);
      };
      return n.cancel = () => {
        clearTimeout(a), a = null;
      }, n;
    };
  });
  var r = n("gjV2B");
  customElements.get("shopping-cart") || customElements.define("shopping-cart", class extends HTMLElement {
    cart={};
    _isQuantityUpdate=!1;
    facets=[ "[data-cart-items]", "[data-cart-promo]", "[data-cart-total]", "[data-cart-checkout]", "[data-cart-delivery]", "[data-cart-recommendations]", "[data-gift-wrap]", "[data-remove-packaging]", "[data-cart-gift-note]", "[data-cart-empty]", "[data-cart-title]" ];
    _requestQueue=new Map;
    _abortController=null;
    _updateController=null;
    async fetchJSON(t, e = {}) {
      const a = await fetch(t, e);
      return a.ok ? a.json() : Promise.reject(a);
    }
    async fetchWithCancellation(t, e = {}, a = null) {
      a && this._requestQueue.has(a) && this._requestQueue.get(a).abort();
      const n = new AbortController, r = {
        ...e,
        signal: n.signal
      };
      a && this._requestQueue.set(a, n);
      try {
        const e = await fetch(t, r);
        return a && this._requestQueue.delete(a), e.ok ? e.json() : Promise.reject(e);
      } catch (t) {
        throw a && t.name, t;
      }
    }
    async update(t = "cart,cart-drawer,cart-drawer-2026,header", e = !1) {
      return this._updateController && this._updateController.abort(), this._updateController = new AbortController, 
      this.fetchJSON(`${location.pathname}?sections=${t}`, {
        signal: this._updateController.signal
      }).then(t => {
        Object.entries(t).forEach(([t, a]) => {
          if (!a) return;
          const n = (new DOMParser).parseFromString(a, "text/html");
          e && (Array.isArray(e) ? e : [ e ]).forEach(t => {
            const e = n.querySelector(t);
            e && this.querySelectorAll(t).forEach(t => t.innerHTML = e.innerHTML);
          }), "header" === t && [ "[data-cart-icon]", "[data-cart-count]" ].forEach(t => {
            const e = n.querySelector(t);
            e && document.querySelectorAll(t).forEach(t => t.innerHTML = e.innerHTML);
          });
        }), this._updateController = null;
      }).catch(t => {
        if ("AbortError" !== t.name) throw this._updateController = null, t;
      });
    }
    toggleCart(t) {
      const e = document.getElementById("Cart");
      e && e.checked !== t && e.click(), this.dispatchEvent(new Event("change")), this.dispatchEvent(new CustomEvent("cart:" + (t ? "open" : "close"), {
        bubbles: !0,
        detail: {
          cart: this.cart
        }
      }));
    }
    open() {
      this.toggleCart(!0);
    }
    close() {
      this.toggleCart(!1);
    }
    dispatchCartUpdate() {
      this.dispatchEvent(new CustomEvent("cart:update", {
        bubbles: !0,
        detail: {
          cart: this.cart
        }
      }));
    }
    updateCount() {
      this.update("header"), this.updateFacets();
    }
    handleChange(t) {
      if (t?.preventDefault(), t?.stopPropagation(), t?.target.hasAttribute("data-ignore-change")) return;
      const e = this.querySelector("[data-cart-items]");
      if (!e) return;
      this._isQuantityUpdate = t?.target && [ "data-quantity", "data-plus", "data-minus" ].some(e => t.target.hasAttribute(e));
      const a = new URLSearchParams(new FormData(e)), n = document.querySelector('cart-gift-note textarea, [name="note"]');
      n && a.set("note", n.value.trim().replace(/\s+/g, " ").replace(/[<>]/g, "")), this.querySelectorAll(`input[type="checkbox"][name][form=${e.id}]`).forEach(t => {
        a.set(t.name, t.checked ? "true" : "false");
      }), document.dispatchEvent(new CustomEvent("spinner:show", {
        detail: {
          source: "shopping-cart"
        }
      })), this.fetchWithCancellation(Shopify.routes.root + "cart/update", {
        method: "POST",
        body: a,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }, "cart-update").then(e => {
        t?.target.hasAttribute("data-ignore-update") || (this.updateLinks(t?.target), this.cart = e, 
        this.dispatchCartUpdate(), e.items.length > 0 && this.updateRecommendations(e.items[0].product_id));
      }).catch(e => {
        "AbortError" !== e.name && (console.warn(e), location.href = t?.target.href);
      }).finally(() => {
        document.dispatchEvent(new CustomEvent("spinner:hide", {
          detail: {
            source: "shopping-cart"
          }
        })), this._isQuantityUpdate = !1;
      });
    }
    setLineItemLoading(t, e = !0) {
      const a = t.closest("[data-line-item]");
      return a ? (e ? (a.classList.add("opacity-50", "pointer-events-none"), a.setAttribute("data-updating", "true")) : (a.classList.remove("opacity-50", "pointer-events-none"), 
      a.removeAttribute("data-updating")), a) : null;
    }
    updateLinks(t) {
      if (!t) return;
      const e = t.closest("[data-line-item]");
      if (!e) return this.updateCount();
      const a = t.href?.match(/=([0-9]+)/);
      if (a && a[1]) {
        const t = parseInt(a[1]), n = e.querySelector('[type="number"]');
        n && (n.value = t), t <= 0 ? (e.classList.add("opacity-0", "max-h-0"), setTimeout(() => e.remove(), 400)) : [ "[data-minus]", "[data-plus]" ].forEach((a, n) => {
          const r = e.querySelector(a);
          r && (r.href = r.href.replace(/[0-9]+$/, t + (n ? 1 : -1)));
        });
      }
      this.updateCount();
    }
    updateFacets() {
      const t = this._isQuantityUpdate ? this.facets.filter(t => "[data-cart-recommendations]" !== t) : this.facets;
      this.update("cart,cart-drawer,cart-drawer-2026", t);
    }
    updateRecommendations(t = this.cart.items[0]?.product_id) {
      t && this.querySelectorAll("related-products").forEach(e => {
        const a = e.dataset.url?.match(/product_id=([0-9]+)/);
        a && parseInt(a[1]) !== t && (e.dataset.url = e.dataset.url.replace(a[1], t));
      });
    }
    async handleClick(t) {
      t.stopPropagation();
      const e = t.target, a = t => e.hasAttribute(t);
      if (a("data-remove")) {
        const a = e.closest("[data-line-item]");
        if (a && a.hasAttribute("data-updating")) return t.preventDefault(), t.stopPropagation(), 
        void t.stopImmediatePropagation();
      }
      if (a("data-minus")) {
        const a = e.closest("[data-line-item]"), n = a?.querySelector('input[type="number"][data-quantity]');
        if (n && parseInt(n.value) <= 1) return t.preventDefault(), t.stopPropagation(), 
        void t.stopImmediatePropagation();
      }
      if (a("data-remove") || a("data-minus") || a("data-plus")) {
        t.preventDefault(), t.stopPropagation(), t.stopImmediatePropagation();
        const n = a("data-remove") ? this.setLineItemLoading(e, !0) : null;
        e.classList.add("pointer-events-none"), document.dispatchEvent(new CustomEvent("spinner:show", {
          detail: {
            source: "shopping-cart"
          }
        })), this._isQuantityUpdate = a("data-plus") || a("data-minus");
        const r = `click-${e.dataset.remove || e.dataset.minus || e.dataset.plus}-${Date.now()}`;
        try {
          const t = await this.fetchWithCancellation(e.href.replace("?", ".js?"), {}, r);
          0 === t.item_count ? this.update("cart,cart-drawer,cart-drawer-2026,header", this.facets) : (this.updateLinks(e), 
          this.cart = t, this.dispatchCartUpdate(), t.items.length > 0 && this.updateRecommendations(t.items[0].product_id));
        } catch (t) {
          "AbortError" !== t.name && (console.warn(t), location.href = e.href);
        } finally {
          document.dispatchEvent(new CustomEvent("spinner:hide", {
            detail: {
              source: "shopping-cart"
            }
          })), n && this.setLineItemLoading(e, !1), e.classList.remove("pointer-events-none"), 
          this._isQuantityUpdate = !1;
        }
      } else if (a("data-add")) {
        t.preventDefault(), t.stopPropagation(), t.stopImmediatePropagation(), e.classList.add("pointer-events-none"), 
        document.dispatchEvent(new CustomEvent("spinner:show", {
          detail: {
            source: "shopping-cart"
          }
        }));
        const a = `add-${e.dataset.add}-${Date.now()}`;
        try {
          await this.fetchWithCancellation(Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              items: [ {
                id: parseInt(e.dataset.add),
                quantity: 1
              } ]
            })
          }, a), this.update();
        } catch (t) {
          "AbortError" !== t.name && (console.warn(t), location.href = e.href);
        } finally {
          document.dispatchEvent(new CustomEvent("spinner:hide", {
            detail: {
              source: "shopping-cart"
            }
          })), e.classList.remove("pointer-events-none");
        }
      }
    }
    getCart(t = !1) {
      this.fetchWithCancellation(Shopify.routes.root + "cart.js", {
        method: "GET",
        headers: {
          Accept: "application/json"
        }
      }, "get-cart").then(t => {
        this.cart = t, this.dispatchCartUpdate();
      }).catch(t => {
        "AbortError" !== t.name && console.error(t);
      });
    }
    disconnectedCallback() {
      this._requestQueue.forEach(t => t.abort()), this._requestQueue.clear(), this._updateController && (this._updateController.abort(), 
      this._updateController = null), this._cleanupSpinnerTranslation && this._cleanupSpinnerTranslation(), 
      this._cleanupSettings && this._cleanupSettings();
    }
    setupLoadingSpinnerTranslation() {
      const t = document.getElementById("Cart"), e = this.querySelector("[data-drawer]"), a = this.querySelector("[data-footer]");
      if (!t || !e) return void console.warn("ShoppingCart: Missing required elements, aborting spinner translation setup");
      const n = window.matchMedia("(min-width: 1024px)"), r = () => {
        if (t.checked) if (n.matches) {
          const t = e.offsetWidth;
          document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
            detail: {
              source: "shopping-cart-drawer",
              transform: `translateX(-${t}px)`
            }
          }));
        } else if (a) {
          const t = a.getBoundingClientRect().height;
          document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
            detail: {
              source: "shopping-cart-drawer",
              transform: `translateY(-${t}px)`
            }
          }));
        } else console.warn("ShoppingCart: Footer not found for mobile transform calculation"); else document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
          detail: {
            source: "shopping-cart-drawer",
            transform: ""
          }
        }));
      }, o = () => {
        setTimeout(() => {
          r(), this.dispatchEvent(new CustomEvent("cart:" + (t.checked ? "open" : "close"), {
            bubbles: !0,
            detail: {
              cart: this.cart
            }
          }));
        }, 10);
      }, i = () => {
        t.checked && r();
      };
      t.addEventListener("change", o), n.addEventListener("change", i), this._cleanupSpinnerTranslation = () => {
        t.removeEventListener("change", o), n.removeEventListener("change", i);
      };
    }
    connectedCallback() {
      this.getCart(), this.openOnAdd = "true" === this.getAttribute("data-open-on-add");
      const t = () => {
        window.dispatchEvent(new CustomEvent("cart:settings", {
          detail: {
            openOnAdd: this.openOnAdd
          }
        }));
      };
      t(), window.addEventListener("cart:settings-request", t), this.addEventListener("input", (0, 
      r.debounce)(t => this.handleChange(t), 300)), this.closest(".shopify-section").addEventListener("click", t => this.handleClick(t)), 
      window.addEventListener("cart:added", () => {
        if (this.update("cart,cart-drawer,cart-drawer-2026,header", this.facets), this.openOnAdd || window.reopenCartOnAdd) {
          const t = document.querySelector("[data-locker]:checked");
          t && "Cart" !== t.id && t.click(), this.open();
        }
        window.reopenCartOnAdd = !1;
      }), window.addEventListener("cart:change", this.handleChange.bind(this)), this.setupLoadingSpinnerTranslation(), 
      this._cleanupSettings = () => {
        window.removeEventListener("cart:settings-request", t);
      };
    }
  });
}();